/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';

import LoginWizard from './LoginWizard';
import messages from 'src/shared/app/authentication/l10n/logInL10n';
import DocumentTitle from 'src/shared/app/base/component/document/DocumentTitle';
import withDoubleDutch from 'src/shared/app/base/vendor/double-dutch/component/hoc/withDoubleDutch';

const useStyles = createUseStyles(styles);

const LoginMain = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <React.Fragment>
      <DocumentTitle>{intl.formatMessage(messages.title)}</DocumentTitle>
      <section className={classes.section}>
        <LoginWizard />
      </section>
    </React.Fragment>
  );
};

export default compose(React.memo, withDoubleDutch)(LoginMain);
